/**
 * Virtual folder sentinel stamped on every synthetic CalendarEvent that represents an
 * agent job on the calendar surface. Not backed by a real Exchange folder — used purely
 * as a discriminator so the surface color/interaction code can recognize these tiles.
 */
export const AGENT_JOB_CALENDAR_FOLDER_ID = 'agent-job-virtual-folder';
